import { connect } from 'react-redux'
import { chatbotSelectors, getStep, PortfolioWizardStepNames } from 'modules/ui/ChatBot'
import { ChatBot } from '../../components'

const mapStateToProps = (state, { push }: any) => ({
  step: getStep(PortfolioWizardStepNames.commission),
  displayStep: chatbotSelectors.getCurrentPortfolioStatus(state) === 'in progress',
  title: 'Commission',
  actions: [],
})

const mapDisptchToProps = (dispatch: any) => ({
  actionClickHandler: (action: any) => dispatch(action()),
})

export default connect(mapStateToProps, mapDisptchToProps)(ChatBot)
